import lodash from "lodash";
import { getAction, listAction } from "@/data/connection";
import { Image } from "@/components/blocks/image/image.class";
import { Article } from "../classes/article.class";
import { File } from "../classes/file.class";
import { Partner } from "../classes/partner.class";
import { Product } from "../classes/product.class";
import { Document } from "../classes/document.class";
import { Exhibition } from "../classes/exhibition.class";
/**
 * Gets a center entry.
 */
export const getExhibitionEntry = function (value, slugOrId, recursive)
{
	return getAction("exhibitions", value, slugOrId, recursive).then(data => {
		if (data.data[0])
			return processEntry(data.data[0]);
		if (data.data)
			return processEntry(data.data);
	});
}

/**
 * Gets a list of centers.
 */
export const getExhibitionsList = function (recursive, page, perPage)
{
	return listAction("exhibitions", recursive, page, perPage).then(data => {
		
		return { content: processList(data.data), totalExhibitions: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Gets Current Exhibition
 */
export const getCurrentExhibitionsList = function (recursive)
{
	return listAction("current-exhibitions", recursive).then(data => {
		return { content: data.data, totalExhibitions: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
}

/**
 * Process Entry.
 */
const processEntry = function(data)
{
	let content = new Exhibition(data);
	// console.log("ExhibitionModel :: processEntry :: content.meta_boc.gallery : ", content.gallery)
	// console.log("ExhibitionModel :: processEntry :: Related_ids : ", data.related_ids)

	// // console.log("Exhibition content:", content)
	
	if (content.image && data.related_ids[content.image[0]])
		content.image = new Image(data.related_ids[content.image[0]]);
	
	if (content.gallery.length  && data.related_ids ) {
		content.gallery = content.gallery.map(id => {
			if (data.related_ids[id])
				return new Image(data.related_ids[id]);
		});
	}

	if (content.videos.length  && data.related_ids ) {
		content.videos = content.videos.map(id => {
			if (data.related_ids[id])
				return new File(data.related_ids[id]);
		});
	}

	// Relations
	if (content.news.length && data.related_ids) {
		content.news = content.news.map(item => {
			if(data.related_ids[item])
				return new Article(data.related_ids[item])
		});
	}
	
	if (content.products.length && data.related_ids) {
		content.products = content.products.map(item => {
			
			let productData = data.related_ids[item];
			let product = new Product(data.related_ids[item])
			
			if (productData.related_ids) {
				if (product.image && productData.related_ids[product.image])
					product.image = new Image(productData.related_ids[product.image])
				
				if (product.gallery) {
					product.gallery = product.gallery.map(image => {
						if(productData.related_ids[image])
							return new Image(productData.related_ids[image])
					});
				}
			}
			return product;
		});
	}

	if (content.documents.length && data.related_ids) {
		content.documents = content.documents.map(item => {
			
			let documentData = data.related_ids[item];
			let document = new Document(data.related_ids[item])

			// console.log("Document", documentData)

			if(documentData.related_ids) {
				if (document.image && documentData.related_ids[document.image])
					document.image = new Image(documentData.related_ids[document.image])
				
				if (document.file && documentData.related_ids[document.file])
					document.file = new File(documentData.related_ids[document.file])
			}
			
			return document;
		});
	}

	if (content.partners && content.partners.length) {
		content.partners = content.partners.map(group => {
			
			group.content = group.content.map(partner => {
				if (partner._get_partner && data.related_ids[partner._get_partner]){
					
					let partnerData = data.related_ids[partner._get_partner];
					let partnerContent = new Partner(partnerData);
					
					// console.log("Partner", partnerData.related_ids)
					
					// console.log("Partner Data: ", partnerData.related_ids[partnerContent.url[0]])
					if (partnerData.related_ids) {
						if ( partnerContent && partnerData.related_ids[partnerContent.url[0]] ) {
							partnerContent.url = partnerData.related_ids[partnerContent.url[0]].source_url;
						}
					}

					partner = partnerContent;
				}
				return partner;
			});

			return group;
		});
	}
	return content;
}

/**
 * Process List.
 */
const processList = function(data)
{
	let content = data;

	content = content.map( value => {
		return processEntry(value)
	})

	return content;
}


// WEBPACK FOOTER //
// ./src/data/models/exhibition.model.js